









import { Component, Vue } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';

@Component({
  components: {
    Loading,
  },
  computed: {
    layout(): string {
      return this.$route.meta.layout || 'default-layout';
    },
  },
})
export default class App extends Vue {}
